import * as React from "react";
import { VisibleImage } from "react-visible-image";
import {
  ImageElement,
  ImageImage,
  GalleryBlockData,
} from "@plinknz/tah-website-elements";
import { SwiperBlock } from "./swiper-block";

export type GalleryBlockName = "ComponentContentBlocksImageGallery";

interface GalleryProps {
  data: GalleryBlockData;
}

interface ImageRenderer {
  heading: string;
  description: string;
  // eslint-disable-next-line react/no-unused-prop-types
  image: ImageImage;
}

export const GalleryBlock = ({ data }: GalleryProps) => {
  const { description, images, heading, autoplay, galleryId } = data;

  function renderer({
    heading: slideHeading,
    description: slideDescription,
    image: { url, alternativeText },
  }: ImageRenderer) {
    return (
      <>
        <div
          className="gallery-slide-image"
          title={alternativeText}
          style={{
            backgroundImage: `url("${url}")`,
          }}
        >
          <VisibleImage className="hidden" src={url} alt={alternativeText} />
        </div>
        {(slideHeading || slideDescription) && (
          <div className="gallery-slide-info">
            {slideHeading && (
              <h4 className="gallery-slide-title">{slideHeading}</h4>
            )}
            {slideDescription && (
              <p className="gallery-slide-description">{slideDescription}</p>
            )}
          </div>
        )}
      </>
    );
  }

  return (
    <SwiperBlock<ImageElement>
      items={images}
      renderer={renderer}
      description={description}
      heading={heading}
      autoplay={autoplay}
      galleryId={galleryId}
    />
  );
};
